import { FunctionComponent, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { useAppBridgeRedirect, useModal } from '@hooks';
import { pendingSubscriptionState } from 'src/states/subscription';
import { Link, TextStyle } from '@shopify/polaris';
import { useRouter } from 'next/router';
import { Routes } from '@routes';

const PendingSubscriptionModal: FunctionComponent = () => {
  const { appBridgeRedirect } = useAppBridgeRedirect();
  const modal = useModal();
  const router = useRouter();
  const [pendingSubscription] = useRecoilState(pendingSubscriptionState);

  useEffect(() => {
    if (pendingSubscription && pendingSubscription.shopifyConfirmationUrl) {
      modal.display(
        () => (
          <TextStyle>
            It looks like you have a pending subscription waiting. Either
            approve to purchase or{' '}
            <Link
              onClick={() => {
                modal.hideModal();
                router.push({
                  pathname: Routes.account.subscription,
                });
              }}
            >
              visit your subscriptions
            </Link>{' '}
            to cancel
          </TextStyle>
        ),
        {
          primaryAction: {
            content: 'Approve',
            onAction: () =>
              appBridgeRedirect(pendingSubscription.shopifyConfirmationUrl!),
          },
          secondaryAction: {
            content: 'Dismiss',
            onAction: () => {
              return;
            },
          },
          title: 'Approve your subscription',
        },
      );
    }
  }, [appBridgeRedirect, modal, pendingSubscription, router]);

  return <></>;
};

export default PendingSubscriptionModal;
